import { render, staticRenderFns } from "./CkTab.vue?vue&type=template&id=3c65bb04&scoped=true&"
import script from "./CkTab.vue?vue&type=script&lang=js&"
export * from "./CkTab.vue?vue&type=script&lang=js&"
import style0 from "./CkTab.vue?vue&type=style&index=0&id=3c65bb04&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c65bb04",
  null
  
)

export default component.exports